import {createSlice} from '@reduxjs/toolkit';
import store from '../../../store';
import { NO_ACCESS_MESSAGE } from '../../../auth/messages';

const NotificationsSlice = createSlice({
    name: "notifications",
    initialState: {
        data: <any>[],
        status: null,
        error: null,
        queryParams: null,
    },
    reducers: {
        setNotifications: (state, action) => {
            const { text, type } = action.payload ?? {};
            // apiFetch and the thunk that called it both report a 403: show that message once.
            if (text === NO_ACCESS_MESSAGE && state.data.some((n: any) => n.text === text && n.type === type)) return;
            const id = new Date().toISOString();
            console.log(action.payload, 'NOTIFICATION')
            state.data.push({...action.payload, id});
            setTimeout(() => {
                store.dispatch(removeNotification(id));
            }, 10000);
        },
        removeNotification: (state, action) => {
            state.data = [...state.data].filter((notification: any) => notification.id !== action.payload)
        },
    },
});
const {reducer} = NotificationsSlice
export const { setNotifications, removeNotification } = NotificationsSlice.actions;
export {reducer};
